// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"0e54f898","419":"43644510","563":"af4e3124","942":"666d8125"}[chunkId] + ".chunk.js";
};